


















import { Component, Prop, Vue } from "vue-property-decorator";

import L from "leaflet";
import {
  LMap,
  LTileLayer,
  LMarker,
  LCircle,
  LPopup,
  LGeoJson,
} from "vue2-leaflet";
import { Icon } from "leaflet";
import Vue2LeafletMarkerCluster from "vue2-leaflet-markercluster";
import { gps } from "@/config/host.config";
import { Geometry, Position } from "@/@types/wiki/geojson";
import { GeoJSON } from "geojson";
type D = Icon.Default & {
  _getIconUrl?: string;
};
delete (Icon.Default.prototype as D)._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});
@Component({
  name: "MarkerMap",
  components: {
    "l-map": LMap,
    "l-tile-layer": LTileLayer,
    "l-marker": LMarker,
    "l-circle": LCircle,
    "v-marker-cluster": Vue2LeafletMarkerCluster,
    "l-popup": LPopup,
    "l-geo-json": LGeoJson,
  },
})
export default class WikiMapDemo extends Vue {
  @Prop({ type: Object, default: {} }) geometry!: Geometry;

  url = gps.osmTile;
  attribution =
    '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors';
  zoom = 12;
  map!: L.Map;
  show = false;
  int: number | undefined;

  $refs!: {
    map: LMap;
  };

  get geojson(): GeoJSON {
    return {
      type: "FeatureCollection",
      features: [
        {
          type: "Feature",
          geometry: this.geometry,
          properties: {},
        },
      ],
    };
  }

  get center(): Array<number> {
    if (!this.geometry || !this.geometry.coordinates) return [55, 37];

    if (this.geometry.type == "Point")
      return [this.geometry.coordinates[1], this.geometry.coordinates[0]];
    if (this.geometry.type == "MultiPoint")
      return [this.geometry.coordinates[1][1], this.geometry.coordinates[1][0]];

    return [55, 37];
  }

  get circle(): { radius: number; lnglat: Array<Position> } {
    if (!this.geometry) return { radius: 0, lnglat: [] };

    if (this.geometry.type == "Point")
      return {
        radius: this.geometry.radius,
        lnglat: [this.geometry.coordinates],
      };

    if (this.geometry.type == "MultiPoint")
      return {
        radius: this.geometry.radius,
        lnglat: this.geometry.coordinates,
      };

    return { radius: 0, lnglat: [] };
  }

  mounted(): void {
    setTimeout(() => {
      this.show = true;
      this.$nextTick(() => {
        this.map = this.$refs.map.mapObject;
        this.$nextTick(() => {
          this.map.attributionControl.setPrefix("Filoxenia");
        });
      });
    }, 200);
  }
}
